import type { SnsWebSdkBaseConfig } from '@sumsub/websdk';

const sumsubSnsWebSdkBaseConfig = {
  // TODO: Remove once this is set in Sumsub itself
  customizationName: 'OTE Branding (Rebrand)',
} satisfies SnsWebSdkBaseConfig;

export { sumsubSnsWebSdkBaseConfig };
